import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NetworkService } from '@app/services/network/network.service';

const NETWORK_ERROR_ROUTES = ['/', '/usuarios/iniciar-sesion', '/usuarios/mi-perfil'];

function getCookie(name: string): string | null {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private networkService: NetworkService, private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = request.headers;

    if (request.url.includes(environment.urlExternalGateway)) {
      return next.handle(request);
    }

    const xsrfToken = getCookie('XSRF-TOKEN');

    if (xsrfToken) {
      headers = headers.set('X-XSRF-TOKEN', xsrfToken);
    }

    const req = request.clone({ withCredentials: true, headers });

    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === 0 && NETWORK_ERROR_ROUTES.includes(this.router.url)) {
          this.networkService.setNetworkError(true);
        }
        return throwError(() => error);
      })
    );
  }
}
